<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>

<div id="header-container">
  <h1 id="header-text">Select Vehicle Programs</h1>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="confirm-button" class="action-button"
            (click)="onConfirm()" [disabled]="selectedPrograms?.length === 0">
      Confirm Selection
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="gfs-table">

    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="vehiclePrograms"
      [columnDefs]="columnHeaders"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="toggleSelection($event)"
      [getRowStyle]="getRowStyle"
    />
  </div>
</div>
